import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import { IconService } from '../services/icon.service';

@Component({
  selector: 'bcac-sound-record',
  templateUrl: './bcac-sound-record.component.html',
  styleUrls: ['./bcac-sound-record.component.scss']
})
export class BcacSoundRecordComponent implements OnInit {

  constructor(
    private render: Renderer2,
    private iconService: IconService,
    private httpClient: HttpClient,
    private messageService: NzMessageService,
  ) { }

  ngOnInit() {
    // this.iconHtml = this.iconService.getSuspendIconSvg;
  }

  @Input()
  iconSize: string = "default";

  @Input()
  tooltipTitle: string = "播放";

  @Input()
  toolTipPlacement: string = "top";

  @Input()
  iconColor: string = "#04a294";

  // iconHtml = this.iconService.getPlayIconSvg;
  playIconSvg = this.iconService.getPlayIconSvg;
  suspendIconSvg = this.iconService.getSuspendIconSvg;
  loadingIconSvg = this.iconService.getLoadingIconSvg;
  video = this.render.createElement("audio");
  source: string;
  showStatus: string = "play";
  playStatus: string = null;

  @Input()
  set bcacSource(value) {
    this.source = value;
  }

  play() {
    // debugger;
    const func1 = () => {
      this.showStatus = "suspend";
    }
    const func2 = () => {
      this.showStatus = "play";
      this.playStatus = "downed";
    }
    this.showStatus = "loading";
    if(this.playStatus) {
      this.video.addEventListener("play", func1);
      this.video.play();
      this.playStatus = "playing";
      this.video.loop = false;
      this.video.addEventListener("ended", func2, false);
      return;
    }
    if(!this.source) {
      this.messageService.error("source is empty.");
    }
    const options: {
      headers?: HttpHeaders,
      observe?: 'body',
      params?: HttpParams,
      reportProgress?: boolean,
      responseType: 'blob',// 'arraybuffer'|'blob'|'json'|'text',     
      withCredentials?: boolean
    } = {
      headers: new HttpHeaders(
        {
          "content-type": "application/json",
          // "X_Auth_Token": "1115c536-2e14-430b-9f1c-a34091a7ce2f"
        }
      ),
      observe: 'body',
      responseType: 'blob'
    };
    let url = this.source;
    this.httpClient.get(url, options).subscribe((res: any)=> {
      if(res.size == 0 || res.type.indexOf("text/html") > -1) {
        this.messageService.error("无录音");
        this.showStatus = "play";
        // this.iconHtml = this.iconService.getPlayIconSvg;
      } else {
        
        let obj_url = window.URL.createObjectURL(res);
        this.video.src = obj_url;
        
        this.video.addEventListener("canplay", func1);
        this.video.play();
        this.playStatus = "play";
        this.video.loop = false;
        
        this.video.addEventListener("ended", func2, false);
      }
    }, error => {
      this.messageService.error(error);
      this.showStatus = "play";
    })
  }

  suspend() {
    this.video.pause();
    this.showStatus = "play";
    this.playStatus = "paused";
  }
}
